export default "__VITE_ASSET__xz$cQNz8__"